export default __webpack_public_path__ + "static/media/para-white-icon-01.2f512e35.svg";